const state = {
  articles: {
    isLoading: false,
    content: [],
    pagination: {},
    totalElements: 0,
  },
  articles2: {
    isLoading: false,
    content: [],
    pagination: {},
    totalElements: 0,
  },
  articles3: {
    isLoading: false,
    content: [],
    pagination: {},
    totalElements: 0,
  },
  article: {},
};

export default state;
